import { Banner } from '@scripsteam/scrips-signal-ds';
import { isPracticeSwitchOn } from '@/shared/lib/practice-switches';
import {
  coPaymentWarningText,
  type CoPaymentWarning,
} from '@/services/scheduling/co-payment-warning';

/**
 * PROD-3347 — says why a price has no patient co-payment: the patient has no
 * active insurance for the appointment's insurer. The price still shows and
 * booking is not blocked (Andrew, 26 Oct). Signal `Banner` warning, the shared
 * piece for a non-blocking warning. Behind `?x=copay-warning`; renders nothing
 * (no spacing either) when there is no warning.
 */
export function CoPaymentWarningBanner({
  warning,
  className,
}: {
  warning: CoPaymentWarning | null | undefined;
  className?: string;
}) {
  if (!warning || !isPracticeSwitchOn('copay-warning')) return null;
  return (
    <Banner variant="warning" className={className}>
      {coPaymentWarningText(warning)}
    </Banner>
  );
}
